"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SystemCheckPageFooter = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _underscore = require("underscore");
var _constants = require("../../../constants");
var _ = require("../..");
var _StudioLogger = require("@studio/logger/StudioLogger");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
var LOG = new _StudioLogger.StudioLogger('SystemCheckPageFooter');
/**
 * SystemCheckPageFooter component renders the footer for the System Check page with navigation and action buttons.
 * @param {string} checkStatus - Current status of the system check
 * @param {boolean} isStandaloneChecker - Whether in standalone checker mode
 * @param {string[]} errors - Array of error messages
 * @param {Function} goToPage - Function to navigate to a different page
 * @param {Function} runSystemCheck - Function to run the system check
 * @param {Function} handleJoinMeeting - Function to handle joining the meeting
 * @param {boolean} isJoinInProgress - Whether the join process is in progress
 * @returns {JSX.Element} The footer component with action buttons
 */
var SystemCheckPageFooter = exports.SystemCheckPageFooter = function SystemCheckPageFooter(_ref) {
  var checkStatus = _ref.checkStatus,
    isStandaloneChecker = _ref.isStandaloneChecker,
    errors = _ref.errors,
    goToPage = _ref.goToPage,
    runSystemCheck = _ref.runSystemCheck,
    handleJoinMeeting = _ref.handleJoinMeeting,
    isJoinInProgress = _ref.isJoinInProgress,
    userBackgroundLoading = _ref.userBackgroundLoading;
  var checkInProgress = checkStatus === _constants.JOIN_PAGE_STATUS.IN_PROGRESS;
  var hasErrors = errors.length > 0 && !checkInProgress;
  var browserBlock = checkStatus === _constants.JOIN_PAGE_STATUS.BROWSER_BLOCK;
  var isJoinButtonDisabled = hasErrors || checkInProgress || browserBlock || isStandaloneChecker || isJoinInProgress || userBackgroundLoading;
  var goToSettingsPage = function goToSettingsPage() {
    return goToPage(_constants.JOIN_PAGE.SETTINGS);
  };
  var joinMeeting = (0, _react.useCallback)((0, _underscore.debounce)(/*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var _t;
    return _regenerator["default"].wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 1;
          return handleJoinMeeting();
        case 1:
          _context.next = 3;
          break;
        case 2:
          _context.prev = 2;
          _t = _context["catch"](0);
          LOG.error('Join meeting failed', {
            error: _t
          });
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 2]]);
  })), 2000, true), [handleJoinMeeting]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_.Button, {
    onClick: goToSettingsPage,
    color: "primary",
    variant: "link",
    disabled: checkInProgress,
    "data-testid": "back_button"
  }, "Back"), /*#__PURE__*/_react["default"].createElement(_.Button, {
    "data-testid": "run-test-button",
    disabled: checkInProgress,
    onClick: runSystemCheck,
    color: "outline"
  }, "Run Test"), /*#__PURE__*/_react["default"].createElement(_.Button, {
    "data-testid": "join-button",
    disabled: isJoinButtonDisabled,
    onClick: joinMeeting,
    color: "primary"
  }, "Join"));
};
SystemCheckPageFooter.propTypes = {
  checkStatus: _propTypes.string.isRequired,
  isStandaloneChecker: _propTypes.bool.isRequired,
  errors: (0, _propTypes.arrayOf)(_propTypes.string).isRequired,
  goToPage: _propTypes.func.isRequired,
  runSystemCheck: _propTypes.func.isRequired,
  handleJoinMeeting: _propTypes.func.isRequired
};